"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Multicall3 = void 0;
const multicall3_abi_js_1 = require("./constants/multicall3.abi.js");
const web3_multicall3_base_js_1 = require("./web3-multicall3.base.js");
const config_constants_js_1 = require("./constants/config.constants.js");
class Web3Multicall3 extends web3_multicall3_base_js_1.BaseWeb3Multicall3 {
    constructor(opts) {
        var _a;
        const address = (_a = opts.address) !== null && _a !== void 0 ? _a : config_constants_js_1.DefaultAddress;
        const contract = new opts.web3.eth.Contract(multicall3_abi_js_1.Multicall3Abi, address);
        super(contract);
    }
}
exports.Web3Multicall3 = Web3Multicall3;
